<template>
    <div>
        <el-form ref="form" :model="form" :disabled="disabled"   :rules="rule" label-width="120px" style="display: flex;flex-wrap: wrap;">
                <div style="width: 100%;margin-bottom: 10px;" class="title">{{ $t('view.投标人信息') }}</div>
                <el-form-item :label="$t('view.投标人')">
                    <el-input  style="width: 320px;" v-model="form.name"  ></el-input>
                </el-form-item>
                <el-form-item :label="$t('view.是否法人')" prop="isLegalRepresentative">
                    <template>
                        <el-radio-group v-model="form.isLegalRepresentative" @change="ChangeIsLegalRepresentative">
                            <el-radio  label="Y" style="width: 145px;">是</el-radio>
                            <el-radio  label="N" style="width: 145px;">否</el-radio>
                        </el-radio-group>
                    </template>
                </el-form-item> 
                <el-form-item :label="$t('view.联系方式')" prop="mobile">
                    <el-input style="width: 320px;" v-model="form.mobile" disabled></el-input>
                </el-form-item>
                <el-form-item :label="$t('view.电子邮箱')" prop="email">
                    <el-input style="width: 320px;" v-model="form.email" disabled></el-input>
                </el-form-item>
             
                
                <el-form-item v-if="form.isLegalRepresentative!='Y'" :label="$t('view.投标授权委托书')" prop="authorizationFileList">
                    <div style="flex: 1" v-if="!form.authorizationFileList.length">
                        <el-upload :action="uploadFileBpm"  :limit="1"
                            :before-upload="beforeAvatarUpload"
                            :data="BpmData"
                            :class="{'hide': form.authorizationFileList.length==1}"
                            ref="authorizationFileList"
                            :headers="headers" :on-success="(res,file)=>{successList(form.authorizationFileList,res,file,'authorizationFileList')}"
                            :on-remove="(res,file)=>{handleRemove('authorizationFileList',res,file)}">
                            <img slot="trigger" style="vertical-align: middle;width: 320px;" :src="require('@/assets/BidDetails/icon-upload'+locale+'.png')">
                        </el-upload>
                    </div>
                    <div v-else style="display: flex;">
                        <File :clsoe="!disabled" :listName="'authorizationFileList'" :file="form.authorizationFileList[0]"></File>
                    </div>
                    <span style="color: #1890ff;cursor: pointer;" @click="downloadTemplate">{{$t('view.下载模版')}}</span>
                </el-form-item>
                <el-form-item v-if="form.isLegalRepresentative!='Y'" :label="$t('view.委托书有效期 ')" prop="authorizationList">
                    <el-date-picker v-model="form.authorizationStart" style="width: 150px;"  value-format="yyyy-MM-dd" type="date" :placeholder="$t('view.请选择开始时间')"></el-date-picker>
                    <span style="margin: 0 8px">-</span> 
                    <el-date-picker v-model="form.authorizationEnd" style="width: 150px;" value-format="yyyy-MM-dd"  type="date" :placeholder="$t('view.请选择结束时间')"></el-date-picker>
                    <!-- <el-date-picker  style="width: 320px;" value-format="yyyy-MM-dd" v-model="form.authorizationList" type="daterange"></el-date-picker> -->
                </el-form-item>
                <el-form-item :label="$t('view.招标联系人')">
                    <el-input style="width: 200px;" v-model="form.bpmNameStr" disabled>
                        <!-- <i v-if="form.bpmNameStr" slot="suffix" class="el-input__icon el-icon-circle-close" @click="claerbpmName"></i> -->
                    </el-input>
                    <el-button style="width: 120px;" type="primary" @click="ChoseContacts">{{ $t('view.选择人员') }}</el-button>
                </el-form-item>
        </el-form>
        <div style="text-align: center" v-if="!disabled">
            <el-button style="min-width: 120px;" v-if="btnShow" @click="PreviousStep " type="primary">{{ $t('view.上一步') }}</el-button>
            <el-button style="min-width: 120px;" @click="authorizationAuthenticate" type="primary">{{ $t('view.提交') }}</el-button>
        </div>
        <el-dialog :visible.sync="ContactsVisible" class="preview" :title="$t('view.选择招标联系人')" :append-to-body="true" width="60%">
            <el-form :model="queryParams" ref="queryBpmUserForm" :inline="true" @submit.native.prevent >
                <el-form-item label="招标联系人（企业认证审核人）" prop="userName">
                    <el-input
                        size="mini"
                        v-model="queryParams.userName"
                        clearable
                        @keyup.enter.native="handleCurrentChange(1)"
                        />
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" size="mini" @click="handleCurrentChange(1)">搜索</el-button>
                    <el-button icon="el-icon-refresh" size="mini" @click="queryParams.userName='';handleCurrentChange(1)">重置</el-button>
                </el-form-item>
            </el-form>
            <div style="color: #B80008;font-size: 14px;margin-bottom: 10px;"> 注：招标联系人请认真选择人员信息，选择错误会影响企业认证审批时效，若不清楚如何选择可联系项目招标公告中联系人或者业务对接人。</div>
            <el-table header-row-class-name="tableHeader" ref="multipleTable"  row-key="bpmId" border max-height="400" :data="listBpmUser" @selection-change="handleSelectionChange">
                <el-table-column type="selection" :reserve-selection="true" width="55" align="center" />
                <el-table-column align="center" fixed type="index" width="60" :label="$t('view.序号')"/>
                <el-table-column label="招标联系人（企业认证审核人）" align="center" prop="userName" />
                <el-table-column label="负责业务" align="center" prop="business" width="180">
                </el-table-column>
                <el-table-column label="状态" align="center" prop="business" width="180">
                    <template slot-scope="scope">
                        {{ scope.row.status==1?$t('view.正常'):$t('view.停用') }}
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination style="text-align: center;" layout="prev, pager, next"  :total="total" @current-change="handleCurrentChange"></el-pagination>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submit">{{ $t('view.确 定') }}</el-button>
                <el-button @click="ContactsVisible=false;handleSelection=[];queryParams.userName='';queryParams.pageNum=1">{{ $t('view.取 消') }}</el-button>
            </div>
        </el-dialog>
    </div>
  </template>
    
<script>
import {authorizationAuthenticate} from '@/api/index'
import {getAuthorization,authorizationVerify,authorizationDownLoad,bpmUserList} from '@/api/project'

import { uploadFileBpm } from '@/utils/request'
import { getToken } from "@/utils/auth";
import File from '@/components/file.vue'
import {getDicts} from '@/api/index'
  export default {
    components:{File},
    props:{
        btnShow:{
            type:Boolean,
            default:false
        },
        ChildForm: {
            type: Object,
            default:{
             
            }
        },
        disabled:{
            type:Boolean,
            default:false
        }
    },
    data(){
        const validateTime = (rule, value, callback) => {
            if (!(this.form.authorizationStart&&this.form.authorizationEnd)) {
                callback(new Error(this.$t('view.请选择')))
            }else if(new Date(this.form.authorizationStart).valueOf()>= new Date(this.form.authorizationEnd).valueOf()){
                callback(new Error(this.$t('view.开始时间不得大于结束时间')))
            }else if (new Date().valueOf()>=new Date(this.form.authorizationEnd).valueOf()) {
                callback(new Error(this.$t('view.大于当前系统时间')))
            } else {
                callback()
            }

        }
        const validateTime1 = (rule, value, callback) => {
            // 期限类型为「长期」(termType=1) 时无需选择营业执照有效期，直接放行
            if (String(this.form.termType) === '1') {
                callback()
                return
            }
            if (!(this.form.businessLicenseStart&&this.form.businessLicenseEnd)) {
                callback(new Error(this.$t('view.请选择')))
            }else if(new Date(this.form.businessLicenseStart).valueOf()>= new Date(this.form.businessLicenseEnd).valueOf()){
                callback(new Error(this.$t('view.开始时间不得大于结束时间')))
            }else if (new Date().valueOf()>=new Date(this.form.businessLicenseEnd).valueOf()) {
                callback(new Error(this.$t('view.大于当前系统时间')))
            } else {
                callback()
            }
        }
      return{
        ContactsVisible:false,//选择招标联系人
        form:{
            authorizationFileList:[],
            corporateIdCardOpposite:[], 
            corporateIdCardFront:[],
        },
        uploadFileBpm,
        url:'',
        BpmData:{type:'qyrzlc'},
        locale: localStorage.getItem('locale')||'zh',
        headers: {
            Authorization:getToken(),
        },
        queryParams:{
            pageNum: 1,
            pageSize: 10,
            userName: null,
        },//招标联系人的表单
        listBpmUser:[],
        handleSelection:[],//选择的数据
        total:0,
        rule: {
            isLegalRepresentative:[{ required: true, message:this.$t('view.请输入') , trigger: "change" }],
            mobile:[{ required: true, message: this.$t('view.请输入'), trigger: "change" }],
            email:[{ required: true, message: this.$t('view.请输入'), trigger: "change" }],
            authorizationFileList:[{ required: true, message: this.$t('view.请上传'), trigger: "change" }],
            authorizationList:[{ required: true, validator: validateTime  ,trigger: "change" }],
           
            setUpTime:[{ required: true, message: this.$t('view.请选择'), trigger: "change" }],
            bankName: [{ required: true, message: this.$t('view.请输入'), trigger: "change" }],
            sectionName:[{ required: true, message: this.$t('view.请输入'), trigger: "change" }],
            bankNo: [{ required: true, message: this.$t('view.请输入'), trigger: "change" }],
            bankAccountName: [{ required: true, message: this.$t('view.请输入'), trigger: "change" }],
            bankAccountNo: [{ required: true, message: this.$t('view.请输入'), trigger: "change" }],
            declareName: [{ required: true, message: this.$t('view.请输入'), trigger: "change" }],
            simpleName: [{ required: true, message: this.$t('view.请输入'), trigger: "change" }],
            realAddress: [{ required: true, message: this.$t('view.请输入'), trigger: "change" }],
            category: [{ required: true, message: this.$t('view.请输入'), trigger: "change" }],
            enterpriseType: [{ required: true, message: this.$t('view.请输入'), trigger: "change" }],
            manufacturingAddress: [{ required: true, message: this.$t('view.请输入'), trigger: "change" }],
            agencyLicenseFileList: [{ required: true, message: this.$t('view.请上传'), trigger: "change" }],
            natureTaxpayer: [{ required: true, message: this.$t('view.请输入'), trigger: "change" }],
            payedCapital: [{ required: true, message: this.$t('view.请输入'), trigger: "change" }],
            threeYearsFinancialReprotFileList:[{ required: true, message: this.$t('view.请上传'), trigger: "change" }],
            suppliedProductName:[{ required: true, message: this.$t('view.请输入'), trigger: "change" }],
            businessLicenseFileList:[{ required: true, message: this.$t('view.请上传'), trigger: "change" }],
            businessLicense:[{ required: true, validator: validateTime1 , trigger: "change" }],
            legalPerson:[{ required: true, message: this.$t('view.请输入'), trigger: "change" }],
            idNo:[{ required: true, message: this.$t('view.请输入'), trigger: "change" }],
            idType:[{ required: true, message: this.$t('view.请选择'), trigger: "change" }],
            isLegalRepresentative:[{ required: true, message: this.$t('view.请输入'), trigger: "change" }],
            mobile:[{ required: true, message: this.$t('view.请输入'), trigger: "change" }],
            email:[{ required: true, message: this.$t('view.请输入'), trigger: "change" }],
            authorizationFileList:[{ required: true, message: this.$t('view.请上传'), trigger: "change" }],
            authorizationList:[{ required: true, validator: validateTime  ,trigger: "change" }],
            productionLicenseFileList:[{ required: true, message: this.$t('view.请上传'), trigger: "change" }],
            businessScope:[{ required: true, message: this.$t('view.请输入'), trigger: "change" }],
            productionCapacity:[{ required: true, message: this.$t('view.请输入'), trigger: "change" }],
            address:[{ required: true, message: this.$t('view.请输入'), trigger: "change" }],
            capital:[{ required: true, message: this.$t('view.请输入'), trigger: "change" }],
            employeesNumber:[{ required: true, message: this.$t('view.请输入'), trigger: "change" }],
            factoryArea:[{ required: true, message: this.$t('view.请输入'), trigger: "change" }],
            revenue:[{ required: true, message: this.$t('view.请输入'), trigger: "change" }],
        },
        btnDis:'',
      }
    },
    watch:{
        ChildForm: {
            handler(val,oldVal) {
                this.form=this.ChildForm
                this.$nextTick(function(){ 
                    this.$refs.form.clearValidate()
                })
            },
        },
       
    },
    methods:{
        ChangeIsLegalRepresentative(e){
            this.$set(this.form,'name',e=='Y'?this.form.legalPerson:this.$store.getters.name)
        },
        claerbpmName(){
            if(this.disabled)
            return
            this.form.bpmNameStr=''
            this.form.bpmIdStr=''
        },
        submit(){
            this.ContactsVisible=false
            this.form.bpmIdStr= this.handleSelection.map(item=>item.bpmId).join(',')
            this.form.bpmNameStr= this.handleSelection.map(item=>item.userName).join(',')
        },
        handleSelectionChange(e){
            this.handleSelection=e
        },  
        handleCurrentChange(e){
            this.queryParams.pageNum=e
            this.bpmUserList()
        },
        bpmUserList(){
            bpmUserList(this.queryParams).then(res=>{
                this.listBpmUser = res.rows;
                this.total = res.total;
                this.ContactsVisible=true
                this.$nextTick(function(){
                    this.listBpmUser.map(item=>{
                        this.$refs.multipleTable.toggleRowSelection(item, false)
                    })
                    if(this.form.bpmIdStr){
                        let list =this.form.bpmIdStr.split(",");
                        list.map(item=>{
                            this.listBpmUser.map(i=>{
                                if(item==i.bpmId){
                                    this.$refs.multipleTable.toggleRowSelection(i, true)
                                }
                            })
                        })
                    }
                })
             
            })
        },
        ChoseContacts(){
            this.bpmUserList()
        },
        // 附件查看与下载
        handleViewFile(filePath, fileName) {
            const ext = filePath.substr(filePath.lastIndexOf('.') + 1, filePath.length)
            if (ext == 'pdf' || 'PDF') {
                window.open(filePath, "_blank");
            } else {
                const eLink = document.createElement("a");
                eLink.download = fileName;
                eLink.style.display = "none";
                eLink.href = filePath;
                document.body.appendChild(eLink);
                eLink.click();
                eLink.remove()
            }
        },
           // 重新上传
        reuploadClick(list){
            this.$set(this.form,list,[])
            this.$forceUpdate()
        },
        PreviousStep(){
            this.$emit('PreviousStep')
        },
        scrollToFirstError() {
            // 获取页面中所有校验错误的元素
            let errorElements = document.querySelectorAll('.el-form-item__error')
            if(errorElements.length > 0){
                // 获取第一个可见的错误元素
                for(let i = 0; i < errorElements.length; i++){
                    let el = errorElements[i]
                    // 检查元素是否在视口中可见
                    let rect = el.getBoundingClientRect()
                    if(rect.width > 0 && rect.height > 0){
                        // 滚动到错误元素对应位置
                        el.scrollIntoView({
                            behavior: 'smooth',
                            block: 'center'
                        })
                        return
                    }
                }
                // 如果没有找到可见的错误元素，滚动到第一个
                errorElements[0].scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                })
            }
        },
        validateForm() {
            return new Promise((resolve) => {
                this.$refs.form.validate((valid) => {
                    resolve(valid);
                });
            });
        },
        authorizationAuthenticate(){
            // 如果有信息表单需要验证（被驳回状态），先验证信息表单
            if (this.$parent.$refs.Information) {
                this.$parent.$refs.Information.validateForm().then((infoValid) => {
                    if (!infoValid) {
                        this.$nextTick(() => {
                            this.scrollToFirstError();
                        });
                        return;
                    }
                    this.validatePersonal();
                });
            } else {
                this.validatePersonal();
            }
        },
        validatePersonal(){
            this.$refs.form.validate((a) => {
                if (a) {

                    // if(this.form.authorizationList&&this.form.authorizationList.length){
                    //     this.form.authorizationEnd=this.form.authorizationList[1]
                    //     this.form.authorizationStart=this.form.authorizationList[0]
                    // }
                    if(!this.form.typeAndBrand.length){
                        this.$message.error(this.$t('view.请添加供货类型及品牌信息'));
                        return
                    }
                    for(let i=0;i<this.form.typeAndBrand.length;i++){
                        if(!this.form.typeAndBrand[i].brand){
                            this.$message.error(this.$t('view.请输入')+this.$t('view.品牌'));
                            return
                        }
                    }
                    let list =[{val:'email',tip:this.$t('view.邮箱')},{val:'name',tip:this.$t('view.姓名')},{val:'phone',tip:this.$t('view.电话')}]
                    for(let i=0;i<list.length;i++){
                        if(!this.form.authorizationContactsList[0][list[i].val]){
                            this.$message.error(this.$t('view.请输入')+this.$t('view.单位管理人') + list[i].tip);
                            return
                        }
                    }
                    const loading = this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    let data =JSON.parse(JSON.stringify(this.form))
                    data.typeAndBrand=JSON.stringify(data.typeAndBrand)
                    authorizationAuthenticate(data).then((res) => {
                        if (res.code == 200) {

                            this.$emit('nextStep')
                        }
                        loading.close();
                    });
                }else {
                    // 数据校验失败
                    // 使用$nextTick的原因是，错误提示的元素是在视图更新后出现的，不使用$nextTick获取元素是undefined
                    this.$nextTick(() => {
                        this.scrollToFirstError()
                    })
                }
            });
        },
    
      beforeAvatarUpload(file){
          // image/png zip rar pdf
        if((!file.type.includes('pdf'))&&(!file.type.includes('image'))&&(!file.type.includes('zip'))&&(!file.type.includes('application/x-compressed'))){
            this.$message.error(this.$t('view.格式有误'));
            return false
        }
        return true
      },
      // 删除
      handleRemove(list, file, fileList) {
        this.$set(this.form,list,[])
        fileList.map(item=>{
            this.form[list].push({
                fileName:item.response.originalFilename,
                filePath:item.response.fileName,
                url: item.response.url, 
            })
        })
      },
      downloadTemplate(){
            authorizationDownLoad().then(res=>{
                const blob = new Blob([res]);
                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = this.$t('view.投标授权委托书模板.docx');
                link.click();
            })
        },
      // 上传文件
      successList(list,res,file,ref){
          // 上传失败
          if(res.code!=200){
            this.$refs[ref].clearFiles();
            return
          }
          if(!list)
          list=[]
          list.push({
              fileName:file.response.data.newFileName,
              filePath:file.response.data.url,
              url: file.response.data.url, 
              type:file.response.data.newFileName.split(".").pop(),
              fileSize:file.size,
              bpmFileId:file.response.data.bpmFileId

          })
      },
 
      
    }
};
  </script>
  <style>
  .line20 .el-form-item__label{
    line-height: 20px !important;
  }
  </style>
  <style lang="scss" scoped>
  ::v-deep.hide .el-upload--picture-card {
    display: none;
  }
  ::v-deep.hide .el-upload--text{
      display: none;
  }
  .annexList{
      display: flex;
      margin-bottom: 20px;
      font-size: 14px;
      color: #303133;
      div:first-child{
          color: #909399;        
      }
  }
  .title{
      font-size: 16px;
      font-weight: 600;
      color: #333333;
  }
  </style>
   